import { styled, Typography } from '@mui/material'

// ------------------------- Color Helper Function ------------------------------------------
const getThemeColor = (theme: any, color?: string) => {
  if (!color) return theme.palette.text.primary
  // Handle theme path like "text.contrastText"
  if (color.includes('.')) {
    const [palette, key] = color.split('.')
    if (palette === 'text' && key === 'contrastText') {
      return theme.palette.text.contrastText
    }
    if (palette === 'text' && key === 'primary') {
      return theme.palette.text.primary
    }
    if (palette === 'text' && key === 'greyOut') {
      return theme.palette.text.greyOut
    }
    if (palette === 'primary' && key === 'main') {
      return theme.palette.primary.main
    }
    if (palette === 'secondary' && key === 'main') {
      return theme.palette.secondary.main
    }
    // Add more theme color mappings as needed
    return color
  }
  return color
}

// ------------------------- Page Title ------------------------------------------
const StyledPageTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.contrastText};
  text-transform: uppercase;
`

export const PageTitle = (props: any) => <StyledPageTitle variant="h1" component="h1" {...props} />

// ------------------------- Section Title ------------------------------------------
const StyledSectionTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>`
  color: ${({ theme, color }) => getThemeColor(theme, color)};
  text-transform: uppercase;
`

export const SectionTitle = (props: any) => <StyledSectionTitle variant="h2" component="h2" {...props} />

// ------------------------- Body Text ------------------------------------------
const StyledBodyText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>`
  color: ${({ theme, color }) => getThemeColor(theme, color)};
`

export const BodyText = (props: any) => <StyledBodyText variant="body1" component="p" {...props} />
